<div class="stick-top">
  <mat-toolbar>
    <mat-icon>shopping_cart</mat-icon> TopUp Success
  </mat-toolbar>
</div>

<div *ngIf="transaction">
  <micro-paymentTransaction-detail [paymentTransactionId]="transaction.id"></micro-paymentTransaction-detail>
</div>
